export interface ScopeCategorization {
	id: string;
	name: string;
	label: string;
	active: 0 | 1;
	mandatoryCiBinding: (typeof MANDATORY_CI_BINDING)[keyof typeof MANDATORY_CI_BINDING];
	firstLevel: 0 | 1;
	monitoring: 0 | 1;
	categories?: CategoryCategorization[];
}

export enum MANDATORY_CI_BINDING {
	NAO_MANDATORIO = 0,
	MANDATORIO = 1,
	MANDATORIO_PARA_FECHAMENTO = 2,
}

export interface CategoryCategorization {
	id: string;
	name: string;
	label: string;
	active: 0 | 1;
	topics?: TopicCategorization[];
}

export interface TopicCategorization {
	id: string;
	name: string;
	label: string;
	active: 0 | 1;
	sla?: number;
	idSla?: string;
}
